import { useEffect, useState, useRef } from "react";
import { makeStyles } from "@mui/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import SelectMD, { SelectProps as SelectPropsMD } from "@mui/material/Select";

import ls from "../../Localization";

const useStyles = makeStyles((theme: any) => ({
	formControl: {
		minWidth: 120
	},
	selectEmpty: {
		marginTop: theme.spacing(2)
	}
}));

interface SelectProps extends Omit<SelectPropsMD, "onChange" | "variant"> {
	id: string;
	name: string;
	value: string;
	hideLabel?: boolean;
	variant?: "outlined" | "standard";
	options: any[];
	onChange(id: string, value: any): void;
	errors?: any;
}

const ls2: any = ls;

function Select({
	id,
	name,
	errors,
	onChange,
	value,
	options,
	variant = "outlined",
	hideLabel,
	required,
	...rest
}: SelectProps) {
	const classes = useStyles({});

	const inputLabel = useRef<HTMLDivElement>(null);
	const [labelWidth, setLabelWidth] = useState<number | null>(0);

	useEffect(() => {
		if (inputLabel.current) {
			setLabelWidth(inputLabel.current.offsetWidth);
		}
	}, [inputLabel]);

	const error = errors ? errors[id] : undefined;

	return (
		<FormControl variant={variant} fullWidth className={classes.formControl}>
			<InputLabel>{hideLabel ? "" : ls2[name]}</InputLabel>
			<SelectMD
				labelId="demo-simple-select-outlined-label"
				id={id}
				value={value}
				onChange={e => onChange(id, e.target.value)}
				label={labelWidth}
				{...rest}
			>
				{options.map(({ id, value, ...rest }) => (
					<MenuItem key={id} value={id} {...rest}>
						{value}
					</MenuItem>
				))}
			</SelectMD>
			<FormHelperText>{error}</FormHelperText>
		</FormControl>
	);
}

export default Select;
